export default __webpack_public_path__ + "static/media/trashcan.94c0a77e.svg";